import { render, staticRenderFns } from "./EdenorFormType.vue?vue&type=template&id=6390508d&"
import script from "./EdenorFormType.vue?vue&type=script&lang=js&"
export * from "./EdenorFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports